<div>
    <mat-tab-group>
        <mat-tab *ngIf="aclGroup.categories" label="Categories">
            <ng-template matTabContent>
                <div>
                    <app-category-config></app-category-config>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.searchTemplate" label="Search Templates">
            <ng-template matTabContent>
                <div>
                    <app-search-config></app-search-config>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.bulkOperations" label="Bulk Operations">
            <ng-template matTabContent>
                <div>
                    <app-bulk-operations></app-bulk-operations>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.userGroups && isAdmin" label="Users and Groups">
            <ng-template matTabContent>
                <div>
                    <app-users-and-groups></app-users-and-groups>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.recordMgmt.dashboard && isRecordsManager" label="Records Management">
            <ng-template matTabContent>
                <div>
                    <app-records-management></app-records-management>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.integration.dashboard && isRulesManager" label="Integration">
            <ng-template matTabContent>
                <div>
                    <app-workflow-integrations></app-workflow-integrations>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.queues && isRulesManager" label="Queues">
            <ng-template matTabContent>
                <div class="p-1">
                    <app-queue-management></app-queue-management>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="aclGroup.redaction.dashboard && showRedaction" label="Redaction">
            <ng-template matTabContent>
                <div>
                    <app-redaction-management></app-redaction-management>
                </div>
            </ng-template>
        </mat-tab>
        <mat-tab *ngIf="isAdmin" label="Settings">
            <ng-template matTabContent>
                <div>
                    <app-admin-config></app-admin-config>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>